import React, { FC, createElement } from 'react';

import {
  StyledParagraph1,
  StyledParagraph2,
  StyledParagraph3,
  StyledParagraph4,
  StyledParagraph5,
} from './styles';

export interface Props {
  level: 1 | 2 | 3 | 4 | 5;
  className?: string;
  bottom?: number;
  color?: string;
}

export const Paragraph: FC<Props> = ({ children, level, className, bottom, color }) => {
  const elements = {
    1: StyledParagraph1,
    2: StyledParagraph2,
    3: StyledParagraph3,
    4: StyledParagraph4,
    5: StyledParagraph5,
  };

  return createElement(elements[level], { className, bottom, color }, children);
};
